import { FC } from 'react';

import NumberFormat from 'react-number-format';

import { BadgeWrapper } from './styled';

export enum MilePriceBadgeVariant {
  SOLID = 'solid',
  TRANSPARENT = 'transparent',
}

export interface IMilePriceBadge {
  milePrice: number;
  className?: string;
  variant?: MilePriceBadgeVariant;
  isRounded?: boolean;
}

const MilePriceBadge: FC<IMilePriceBadge> = ({
  milePrice,
  className,
  variant = MilePriceBadgeVariant.TRANSPARENT,
  isRounded = false,
}) => {
  return milePrice >= 0 ? (
    <BadgeWrapper className={className} variant={variant} isRounded={isRounded}>
      <NumberFormat
        value={milePrice}
        displayType='text'
        thousandSeparator='.'
        decimalSeparator=','
        decimalScale={2}
      />
      <sup> mil</sup>
    </BadgeWrapper>
  ) : null;
};

export default MilePriceBadge;
